import MarkAttendanceCourseView from './component';
import _routes from './routes';

export const routes = _routes;

export default MarkAttendanceCourseView;



// WEBPACK FOOTER //
// ./containers/Group/Attendance/MarkAttendance/MarkAttendanceCourseView/index.js